import React from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { FieldGroup, FormField } from 'components/formKit'
import type { FONT_LIST_FIELDS } from 'services/Branding/fieldConfigs'

export interface IDefaultListFontFormProps {
  font: typeof FONT_LIST_FIELDS
  children?: React.ReactNode
}

const DefaultListFontForm: React.FC<IDefaultListFontFormProps> = ({ font, children }) => {
  return (
    <Padding gap sides>
      {children}
      <FieldGroup config={font.fontStyleGroup}>
        <FormField config={font.fontWeight} />
        <FormField config={font.fontStyle} />
      </FieldGroup>
      <FormField config={font.spacing} />
      <FormField config={font.gap} />
      <FormField config={font.color} />
    </Padding>
  )
}

export default DefaultListFontForm
